import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileFrame from '@/components/MobileFrame';
import { Icon } from '@/components/Icons';
import { tpl, useT } from '@/lib/i18n';
import { useOnboardingStore } from '@/lib/store';
import { setPhone as apiSetPhone, sendPhoneOtp } from '@/lib/onboarding-api';

export default function PhoneScreen() {
    const t = useT();
    const navigate = useNavigate();
    const phone = useOnboardingStore((s) => s.phone);
    const setPhone = useOnboardingStore((s) => s.setPhone);
    const [submitting, setSubmitting] = useState(false);
    const [err, setErr] = useState<string | null>(null);

    const digits = phone.replace(/\D/g, '');
    const valid = digits.length >= 9 && digits.length <= 13 && digits.startsWith('8');

    const handleContinue = async () => {
        try {
            setSubmitting(true);
            setErr(null);
            await apiSetPhone(digits);
            await sendPhoneOtp();
            navigate('/onboarding/otp');
        } catch (e) {
            setErr(e instanceof Error ? e.message : t.somethingWrong);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <MobileFrame
            progress={(3 / 7) * 100}
            showBack
            stepLabel={tpl(t.stepOf, { current: 3, total: 7 })}
        >
            <div
                className="fade-in"
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '8px 24px 28px',
                }}
            >
                <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>{t.phoneTitle}</h1>
                <p
                    style={{
                        fontSize: 14,
                        lineHeight: 1.55,
                        color: 'var(--ink-500)',
                        marginBottom: 28,
                    }}
                >
                    {t.phoneSubtitle}
                </p>

                <label className="field-label">{t.phoneLabel}</label>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: 48,
                        border: '1px solid var(--ink-200)',
                        borderRadius: 10,
                        overflow: 'hidden',
                        background: 'var(--surface)',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            padding: '0 12px',
                            height: '100%',
                            borderRight: '1px solid var(--ink-200)',
                            background: 'var(--ink-50)',
                        }}
                    >
                        <div style={{ width: 20, height: 14, display: 'flex', flexDirection: 'column' }}>
                            <div style={{ flex: 1, background: '#E70011' }} />
                            <div style={{ flex: 1, background: '#fff' }} />
                        </div>
                        <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink-700)' }}>+62</span>
                    </div>
                    <input
                        className="field-input"
                        style={{ border: 'none', height: '100%', boxShadow: 'none' }}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value.replace(/[^\d\s]/g, ''))}
                        placeholder="812 3456 7890"
                        inputMode="numeric"
                        autoFocus
                    />
                </div>
                <p className="field-hint" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <Icon name="info" size={13} color="var(--ink-400)" />
                    {t.phoneHint}
                </p>

                {err && (
                    <div
                        className="chip chip-error"
                        style={{ marginTop: 12, alignSelf: 'flex-start' }}
                    >
                        <Icon name="alert" size={14} /> {err}
                    </div>
                )}

                <div style={{ flex: 1 }} />

                <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    disabled={!valid || submitting}
                    onClick={handleContinue}
                >
                    {submitting ? <div className="spinner" /> : t.sendOtp}
                </button>
            </div>
        </MobileFrame>
    );
}
